var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "table",
      staticClass: "c-table",
      class: {
        "c-table_scrolled": _vm.isScrolled,
        "c-table_scroll_end": _vm.isScrollEnd,
        "c-table_scroll": _vm.isScroll,
      },
    },
    [
      _c("m-column-filters", {
        ref: "columnFilters",
        attrs: {
          column: _vm.filteredColumn,
          "reference-list": _vm.referenceList,
          "active-filters": _vm.activeFilteredColumns,
        },
        on: {
          getReferenceValues: _vm.getReferenceValues,
          close: function ($event) {
            _vm.filteredColumn = null
          },
          setFilter: _vm.setColumnFilter,
          removeFilter: _vm.removeColumnFilter,
        },
      }),
      _vm.displayShadow
        ? _c("div", {
            class: {
              "c-table__shadow": _vm.data.actions,
              "c-table__shadow_active": _vm.data.actions,
              // 'c-table__empty__shadow': data.isGroupByCategory && hideCollapseGroups.length === data.records.length
            },
          })
        : _vm._e(),
      _vm.isScroll
        ? _c("div", { staticClass: "c-table__scrollbar-wrapper" })
        : _vm._e(),
      _c(
        "perfect-scrollbar",
        {
          ref: "wrapper",
          staticClass: "c-table__wrapper",
          on: { scroll: _vm.scroll },
        },
        [
          _c(
            "table",
            { ref: "container", staticClass: "c-table__container" },
            [
              _vm.displayTableHead
                ? _c(
                    "thead",
                    { ref: "header", staticClass: "c-table__header" },
                    _vm._l(_vm.levels, function (i) {
                      return _c(
                        "tr",
                        { key: i, staticClass: "c-table__header-row" },
                        [
                          _vm._l(_vm.getTableColumns(i), function (column) {
                            return _c(
                              "th",
                              {
                                key: column.id,
                                staticClass: "c-table__column",
                                class: {
                                  "c-table__column_with_filter": column.type,
                                  "c-table__column_hidden": _vm.isDisabled(
                                    column.id
                                  ),
                                  "c-table__column_sorted":
                                    _vm.isSorted(column),
                                },
                                attrs: {
                                  id: `c-table-column-${column.id}`,
                                  colspan: _vm.getColspan(column),
                                  rowspan: _vm.getRowspan(column),
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "c-table__column-wrapper" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "c-table__column-label",
                                        class: {
                                          "c-table__column-label-children":
                                            !_vm.isCategory(column) &&
                                            _vm.sortedColumn,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.setSortedColumn(
                                              column,
                                              _vm.sortedColumn
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(" " + _vm._s(column.label) + " ")]
                                    ),
                                    column.description || column.type
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "c-table__column-actions",
                                          },
                                          [
                                            column.fullName
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "c-table__column-action c-table__column-action_description",
                                                  },
                                                  [
                                                    _c("c-button", {
                                                      attrs: {
                                                        id: `table-column-button-description-${column.id}`,
                                                        size: "small",
                                                        icon: "info",
                                                        "no-border": "",
                                                      },
                                                    }),
                                                    _c(
                                                      "b-popover",
                                                      {
                                                        attrs: {
                                                          placement: "top",
                                                          triggers: "hover",
                                                          target: `table-column-button-description-${column.id}`,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              column.fullName
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm.isColumnFiltered(column.id)
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "c-table__column-action",
                                                  },
                                                  [
                                                    _c("c-button", {
                                                      attrs: {
                                                        id: `table-column-button-filter-${column.id}`,
                                                        size: "small",
                                                        "no-border": "",
                                                        active:
                                                          _vm.isColumnActiveFiltered(
                                                            column.id
                                                          ),
                                                        icon: {
                                                          icon: "filter-column",
                                                          activeColor: "blue",
                                                        },
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.openColumnFilterModal(
                                                            column
                                                          )
                                                        },
                                                      },
                                                    }),
                                                    _c(
                                                      "b-popover",
                                                      {
                                                        attrs: {
                                                          placement: "top",
                                                          triggers: "hover",
                                                          target: `table-column-button-filter-${column.id}`,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.isColumnActiveFiltered(
                                                                column.id
                                                              )
                                                                ? "Изменить фильтр"
                                                                : "Применить фильтр"
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ]
                            )
                          }),
                          _vm.data.actions && i === 1
                            ? _c(
                                "th",
                                {
                                  staticClass:
                                    "c-table__column c-table__column_actions",
                                  attrs: {
                                    id: "c-table-actions-element",
                                    rowspan: _vm.levels,
                                  },
                                },
                                [
                                  _c("div", {
                                    staticClass: "c-table__column-empty",
                                  }),
                                ]
                              )
                            : _vm._e(),
                        ],
                        2
                      )
                    }),
                    0
                  )
                : _vm._e(),
              !_vm.data.isGroupByCategory
                ? _c(
                    "tbody",
                    { staticClass: "c-table__records" },
                    _vm._l(_vm.sortedRecords, function (record, recordIndex) {
                      return _c(
                        "tr",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: record.isShowRow,
                              expression: "record.isShowRow",
                            },
                          ],
                          key: recordIndex,
                          staticClass: "c-table__record",
                        },
                        [
                          _vm._l(
                            _vm.getTableColumns(_vm.levels),
                            function (column, cellIndex) {
                              return _c(
                                "td",
                                {
                                  key: column.id,
                                  staticClass: "c-table__cell",
                                  class: {
                                    "c-table__cell_string":
                                      column.type === "string",
                                    "c-table__cell_reference":
                                      column.type === "reference",
                                    "c-table__cell_number":
                                      column.type === "number",
                                    "c-table__cell_archive":
                                      record.is_archive.value == 1,
                                    "c-table__cell_date":
                                      column.type === "date",
                                    "c-table__cell_hidden": _vm.isDisabled(
                                      column.id
                                    ),
                                    ["c-table__cell_" + column.id]: column.id,
                                  },
                                },
                                [
                                  column.id === "name"
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "c-table__cell-value 1",
                                          staticStyle: {
                                            display: "flex",
                                            "align-items": "center",
                                          },
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(record[column.id].value)
                                            ),
                                          ]),
                                          record.is_vacant.value !== "0"
                                            ? _c("svg-icon", {
                                                directives: [
                                                  {
                                                    name: "b-popover",
                                                    rawName:
                                                      "v-b-popover.hover.blur.top",
                                                    value:
                                                      "Для должности есть вакансия",
                                                    expression:
                                                      "'Для должности есть вакансия'",
                                                    modifiers: {
                                                      hover: true,
                                                      blur: true,
                                                      top: true,
                                                    },
                                                  },
                                                ],
                                                staticStyle: {
                                                  display: "inline-flex",
                                                  "margin-left": "10px",
                                                },
                                                attrs: { name: "vacancy" },
                                              })
                                            : _vm._e(),
                                        ],
                                        1
                                      )
                                    : _vm.isDefaultCell(record, column)
                                    ? _c(
                                        "div",
                                        { staticClass: "c-table__cell-value" },
                                        [
                                          _vm._v(
                                            _vm._s(record[column.id].value)
                                          ),
                                        ]
                                      )
                                    : _vm.isFilialSettingsCell(record, column)
                                    ? _c("c-table-cell", {
                                        staticClass: "c-table__cell-cell",
                                        attrs: {
                                          "post-code": record.code.value,
                                          "cell-index": cellIndex,
                                          "cell-value": record[column.id].value,
                                          column: column,
                                          "filial-settings":
                                            record.filialSettings.value,
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              )
                            }
                          ),
                          _vm.data.actions
                            ? _c(
                                "td",
                                {
                                  staticClass:
                                    "c-table__cell c-table__cell_actions",
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "c-table__cell-actions" },
                                    [
                                      _c("c-table-actions", {
                                        attrs: {
                                          record: record,
                                          "post-code": record.code.value,
                                          "is-archive": record.is_archive.value,
                                          "count-workers": _vm.getCountWorkers(
                                            record.code.value
                                          ),
                                        },
                                        on: { removePost: _vm.removePost },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        2
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _vm._l(_vm.sortedRecords, function (group, groupIndex) {
                return _c(
                  "tbody",
                  {
                    key: `body-${groupIndex}`,
                    staticClass: "c-table__records",
                  },
                  [
                    _vm.data.isGroupByCategory
                      ? [
                          _c(
                            "tr",
                            {
                              directives: [
                                {
                                  name: "b-toggle",
                                  rawName: "v-b-toggle",
                                  value: `category-collapse-${groupIndex}`,
                                  expression:
                                    "`category-collapse-${groupIndex}`",
                                },
                              ],
                              staticClass: "c-table__record",
                            },
                            [
                              _c(
                                "td",
                                {
                                  staticClass:
                                    "c-table__cell__collapse__button",
                                  attrs: {
                                    colspan:
                                      _vm.getTableColumns(_vm.levels).length +
                                      1,
                                  },
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      staticClass:
                                        "c-table__cell__collapse__button__icon",
                                      attrs: {
                                        width: "22",
                                        height: "22",
                                        viewBox: "0 0 22 22",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                      },
                                    },
                                    [
                                      _c("circle", {
                                        attrs: {
                                          cx: "11",
                                          cy: "11",
                                          r: "10.5",
                                          fill: "white",
                                          stroke: "#D3D8DF",
                                        },
                                      }),
                                      _c("path", {
                                        attrs: {
                                          d: "M10.5398 13.4727C10.2813 13.2141 10.2813 12.7948 10.5398 12.5361L13.87 9.20431C14.1285 8.94569 14.5476 8.94569 14.8061 9.20432C15.0646 9.46294 15.0646 9.88225 14.8061 10.1409L11.4759 13.4727C11.2174 13.7313 10.7983 13.7313 10.5398 13.4727Z",
                                          fill: "#0066FF",
                                        },
                                      }),
                                      _c("path", {
                                        attrs: {
                                          d: "M11.4706 13.4727C11.7291 13.2141 11.7291 12.7948 11.4706 12.5361L8.12999 9.19397C7.87149 8.93534 7.45238 8.93534 7.19388 9.19397C6.93537 9.45259 6.93537 9.8719 7.19388 10.1305L10.5345 13.4727C10.793 13.7313 11.2121 13.7313 11.4706 13.4727Z",
                                          fill: "#0066FF",
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(
                                    " " + _vm._s(group.categoryName) + " "
                                  ),
                                  _c("div", {
                                    staticClass:
                                      "c-table__cell__collapse__button__border__right",
                                  }),
                                ]
                              ),
                              _vm.data.actions
                                ? _c(
                                    "td",
                                    {
                                      staticClass:
                                        "c-table__cell c-table__cell_actions",
                                    },
                                    [
                                      _c("div", {
                                        staticClass:
                                          "c-table__cell-actions c-table__cell-actions-collapse-button",
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                          _vm._l(group.records, function (record, recordIndex) {
                            return _c(
                              "b-collapse",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: record.isShowRow,
                                    expression: "record.isShowRow",
                                  },
                                ],
                                key: recordIndex,
                                staticClass: "c-table__record",
                                attrs: {
                                  id: `category-collapse-${groupIndex}`,
                                  tag: "tr",
                                  visible: "",
                                },
                              },
                              [
                                _vm._l(
                                  _vm.getTableColumns(_vm.levels),
                                  function (column, cellIndex) {
                                    return _c(
                                      "td",
                                      {
                                        key: column.id,
                                        staticClass: "c-table__cell",
                                        class: {
                                          "c-table__cell_string":
                                            column.type === "string",
                                          "c-table__cell_reference":
                                            column.type === "reference",
                                          "c-table__cell_number":
                                            column.type === "number",
                                          "c-table__cell_archive":
                                            record.is_archive.value == 1,
                                          "c-table__cell_date":
                                            column.type === "date",
                                          "c-table__cell_hidden":
                                            _vm.isDisabled(column.id),
                                          ["c-table__cell_" + column.id]:
                                            column.id,
                                        },
                                      },
                                      [
                                        column.id === "name"
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "c-table__cell-value",
                                                staticStyle: {
                                                  display: "flex",
                                                  "align-items": "center",
                                                },
                                              },
                                              [
                                                record.is_archive.value == 1 &&
                                                _vm.getCountWorkers(
                                                  record.code.value
                                                ) > 0
                                                  ? _c("c-alarm", {
                                                      staticClass:
                                                        "cell-filial-settings__icon",
                                                      attrs: {
                                                        "cell-index": cellIndex,
                                                        "post-code":
                                                          record.code.value,
                                                        "count-workers":
                                                          _vm.getCountWorkers(
                                                            record.code.value
                                                          ),
                                                      },
                                                    })
                                                  : _vm._e(),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      record[column.id].value
                                                    )
                                                  ),
                                                ]),
                                                record.is_vacant.value !== "0"
                                                  ? _c("svg-icon", {
                                                      directives: [
                                                        {
                                                          name: "b-popover",
                                                          rawName:
                                                            "v-b-popover.hover.blur.top",
                                                          value:
                                                            "Для должности есть вакансия",
                                                          expression:
                                                            "'Для должности есть вакансия'",
                                                          modifiers: {
                                                            hover: true,
                                                            blur: true,
                                                            top: true,
                                                          },
                                                        },
                                                      ],
                                                      staticStyle: {
                                                        display: "inline-flex",
                                                        "margin-left": "10px",
                                                      },
                                                      attrs: {
                                                        name: "vacancy",
                                                      },
                                                    })
                                                  : _vm._e(),
                                              ],
                                              1
                                            )
                                          : _vm.isDefaultCell(record, column)
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "c-table__cell-value",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      record[column.id].value
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            )
                                          : _vm.isFilialSettingsCell(
                                              record,
                                              column
                                            )
                                          ? _c("c-table-cell", {
                                              staticClass: "c-table__cell-cell",
                                              attrs: {
                                                "post-code": record.code.value,
                                                "cell-index": cellIndex,
                                                "cell-value":
                                                  record[column.id].value,
                                                column: column,
                                                "filial-settings":
                                                  record.filialSettings.value,
                                              },
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                _vm.data.actions
                                  ? _c(
                                      "td",
                                      {
                                        staticClass:
                                          "c-table__cell c-table__cell_actions",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "c-table__cell-actions",
                                          },
                                          [
                                            _c("c-table-actions", {
                                              attrs: {
                                                record: record,
                                                "post-code": record.code.value,
                                                "is-archive":
                                                  record.is_archive.value,
                                                "count-workers":
                                                  _vm.getCountWorkers(
                                                    record.code.value
                                                  ),
                                              },
                                              on: {
                                                removePost: _vm.removePost,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              2
                            )
                          }),
                        ]
                      : _vm._e(),
                  ],
                  2
                )
              }),
            ],
            2
          ),
        ]
      ),
      (_vm.data.activeFilteredColumns.length > 0 ||
        _vm.data.globalFilters.length > 0) &&
      _vm.data.records.length === 0
        ? _c("div", { staticClass: "c-table__empty__records" }, [
            _vm._v(" " + _vm._s(_vm.emptyRecordsLabel) + " "),
          ])
        : _vm._e(),
      _vm.data.records.length === 0 &&
      _vm.data.activeFilteredColumns.length === 0 &&
      _vm.data.globalFilters.length === 0
        ? _c("div", { staticClass: "c-table__empty__posts__not__added" }, [
            _vm._v(" Должности для группы "),
            _c("b", [_vm._v(_vm._s(_vm.currentGroupName))]),
            _vm._v(" пока не добавлены "),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }